export type StartingPointSettings={staff_payday_month_day:number;staff_payday_weekday:number};
export function lastDueStaffPeriod(today:string,payPer:string|null|undefined,settings:StartingPointSettings){
 const d=new Date(`${today}T00:00:00Z`);
 if(payPer==="day"){
  d.setUTCDate(d.getUTCDate()-(d.getUTCDay()-settings.staff_payday_weekday+7)%7);
 }else{
  const last=new Date(Date.UTC(d.getUTCFullYear(),d.getUTCMonth()+1,0)).getUTCDate();
  const due=Math.min(settings.staff_payday_month_day,last);
  d.setUTCDate(1);
  if(Number(today.slice(8,10))<due)d.setUTCMonth(d.getUTCMonth()-1);
  d.setUTCDate(0);
 }
 return d.toISOString().slice(0,10);
}
export function defaultStaffStartingPoint(hireDate:string,payPer:string|null|undefined,today:string,settings:StartingPointSettings){
 const end=lastDueStaffPeriod(today,payPer,settings);
 return end>=hireDate?end:null;
}
